var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7C3.75 6.30964 4.30964 5.75 5 5.75H19C19.6904 5.75 20.25 6.30964 20.25 7C20.25 7.69036 19.6904 8.25 19 8.25H5C4.30964 8.25 3.75 7.69036 3.75 7Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12C3.75 11.3096 4.30964 10.75 5 10.75H19C19.6904 10.75 20.25 11.3096 20.25 12C20.25 12.6904 19.6904 13.25 19 13.25H5C4.30964 13.25 3.75 12.6904 3.75 12Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.75C4.30964 15.75 3.75 16.3096 3.75 17C3.75 17.6904 4.30964 18.25 5 18.25H19C19.6904 18.25 20.25 17.6904 20.25 17C20.25 16.3096 19.6904 15.75 19 15.75H5Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.44385bea8e0c0451690d14d51bf48caa.svg";
export { ForwardRef as ReactComponent };